import * as _ from 'underscore';
import { IListResource } from '../../ts/resources/Resource';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IUserNotification } from '../models/IUserNotification';
import { GetUserNotificationsRequest } from '../redux/serverRequests/GetUserNotificationsRequest';
import { SliceableHelper } from '../../ts/helpers/SliceableHelper';
import { ServiceLocator } from '../../app/ServiceLocator';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { UpdateLastSeenUserNotificationRequest } from '../redux/serverRequests/UpdateLastSeenUserNotification';
import { ServerService } from '../../ts/services/ServerService';
import { IRequest } from '../../ts/ServerApi/types/IRequest';
import { CheckHasUnseenUserNotificationsRequest } from '../redux/serverRequests/CheckHasUnseenUserNotificationsRequest';

class UserNotificationsResource implements IListResource<IUserNotification> {

    private listFetcher: IListFetcher<IUserNotification> = new WebClientListResourceFetcher(GetUserNotificationsRequest, ServerApiMapper.userNotifications);

    public all(): ResourceQuery<IUserNotification> {
        return new ResourceQuery(this.listFetcher);
    }

    public getAllUserNotifications() {
         return SliceableHelper.fetchAll(this.all()).then(listResult => _.indexBy(listResult.items, 'id'));
    }

    public updateNotificationsStatus(ids: string[], isRead: boolean): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }

    public deleteNotifications(ids: string[]): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }

    public checkHasUnseenUserNotifications(): Promise<boolean> {
      return this.sendRequest(
        new CheckHasUnseenUserNotificationsRequest());
    }

    public updateLastSeenUserNotification(id: string): Promise<{}> {
      return this.sendRequest(
        new UpdateLastSeenUserNotificationRequest({ lastSeenUserNotificationId: id }));
    }

    private sendRequest<TParams, TResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
      return toNativePromise(this.server().sendRequest(request));
    }

    private server(): ServerService {
      return ServiceLocator.get<ServerService>('ServerService');
    }
}

export const UserNotificationsResources = new UserNotificationsResource();
